function extractErrors(e) {
  // Catch 500 errors
  if(e.response && e.response.status === 500) {
    return {
      base: ["Something went wrong, please try again later"]
    }
  }
  if(e.response && e.response.data && e.response.data.errors) {
    return e.response.data.errors
  }

  return {
    base: [e.message]
  }
}

export default extractErrors

